<div class="cart-totals-coupon-loader">
  <div class="dot" [class.dot-dark]="activeIndex() === 0"></div>
  <div class="dot" [class.dot-dark]="activeIndex() === 1"></div>
  <div class="dot" [class.dot-dark]="activeIndex() === 2"></div>
</div>
